<template>
  <div>
    <v-row>
      <v-col
          cols="6"
          sm="6"
          md="3"
          v-for="(availability, index) in reversedAvailabilityList"
          :key="index"
      >
        <v-card
            rounded="0"
            border
            elevation="0"
            :class="isActiveAvailability(availability.id) ? 'bg-tertiary' : ''"
            class="pa-3 text-center cursor-pointer"
            @click="onAvailabilityChange(availability)"
        >
          {{ availability.name }}
        </v-card>
      </v-col>
    </v-row>
    <v-row v-show="error && error.length">
      <v-col cols="12">
        <v-alert type="error">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
  </div>  
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import { useRcaStore } from '~/plugins/store/rca';
import type {RcaAvailability} from "~/types/Rca";

export default defineComponent({
  name: 'RcaRadioAvailabilityListVuetify',
  props: {
    modelValue: {
      type: [Array, Number, null] as PropType<number[] | number | null>,
      default: () => [6, 12] as number[],
    },
  },
  setup(props, { emit }) {
    const rcaStore = useRcaStore();
    const selectedAvailability = ref(props.modelValue);
    const availabilityList = ref<RcaAvailability[]>([]);
    const error = ref('');

    const fetchAvailabilities = async () => {
      availabilityList.value = await rcaStore.getAvailabilities();
    };

    onMounted(() => {
      fetchAvailabilities();

      // Listen for validate event
      window.addEventListener('validate-rca', (data) => {
        if (data.detail && data.detail === 'availability') {
          if (!selectedAvailability.value) {
            error.value.push('Acest câmp este obligatoriu');
          } else {
            error.value = '';
            emit('validation-rca-status', { field: 'availability', isValid: true });
          }
        }
      });
    });

    const reversedAvailabilityList = computed(() => {
      return [...availabilityList.value].reverse();
    });

    const isActiveAvailability = (availabilityId: number) => {
      if (Array.isArray(selectedAvailability.value)) {
        return selectedAvailability.value.includes(availabilityId);
      }
      return selectedAvailability.value === availabilityId;
    };

    const onAvailabilityChange = (availability: RcaAvailability) => {
      selectedAvailability.value = availability.id;
      emit('update:modelValue', availability.id);
    };

    watch(() => props.modelValue, (newValue) => {
      error.value = '';
      selectedAvailability.value = newValue;
      const isValid = !!newValue;
      emit('validation-rca-status', { field: 'availability', isValid });
    });

    return {
      reversedAvailabilityList,
      isActiveAvailability,
      onAvailabilityChange,
      error,
    };
  },
});
</script>

<style scoped>
</style>
